import React from 'react';
import { DatePicker } from '@oscar/theme';
import moment from 'moment';
import { FORMAT_DATE } from 'common/constants';

const DatePickerPopulate = (props: any) => {
  const { value } = props;
  return (
    <>
      {value ? (
        <DatePicker
          {...props}
          value={moment(value, FORMAT_DATE.FULL_DATETIME)}
          style={{ width: '100%' }}
        />
      ) : (
        <DatePicker {...props} style={{ width: '100%' }} />
      )}
    </>
  );
};

export default DatePickerPopulate;
